import {Pagination} from '../pagination.model';
import {Invoice} from '../../../../bills/shared/model/invoice.model';

export class InvoicePage extends Pagination {
  content: Invoice[] = [];
}
